// extracted by mini-css-extract-plugin
module.exports = {"linkUrl":"_1SRSv","billTip":"_2rA-1","btnStatus":"_2n7ai","disabledBtnStatus":"_2Gd8O"};